// Per-device conveniences only (remembered organisation and pilot). Storage can be unavailable
// (private windows, blocked site data), so every access is guarded and the app works without it.

const PREFIX = 'endurance-kb.';

export function readPref(key: string): string | null {
  try {
    return window.localStorage.getItem(PREFIX + key);
  } catch {
    return null;
  }
}

export function writePref(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(PREFIX + key);
    else window.localStorage.setItem(PREFIX + key, value);
  } catch {
    // Not remembering is fine.
  }
}

export const prefs = {
  realm: 'realm',
  tenant: 'tenant',
};
